import type { Role } from './types.js'

export const campaignCreatorProfiles = ['Administrador', 'Gerente', 'Planejamento', 'Atendimento'] as const

export function canCreateCampaign(role: Role | string, profile: string) {
  return role === 'admin' || role === 'manager' || campaignCreatorProfiles.includes(profile as typeof campaignCreatorProfiles[number])
}

export function hasFullCampaignClientAccess(role: Role | string, profile: string) {
  return role === 'admin' || role === 'manager' || profile === 'Administrador'
}
